module.exports = __webpack_public_path__ + "img/feixinjiaju7.349a1d21.jpg";